// @flow
import React, { type Node } from 'react';
import range from 'ramda/es/range';

import type { SubjectList } from 'app/dataTypes/ScheduleWeek.types';
import config from 'app/config';

import ScheduleRow from './ScheduleRow';
import ScheduleRowTemplate from './ScheduleRowTemplate';
import { availableTabs as at } from './Tab';


type Props = {
  data: SubjectList,
  currentTab: $Values<typeof at>,
  studentId: string,
}

const ScheduleTableContent = ({ data, currentTab, studentId }: Props): Node => {
  const lessons: Array<number> = range(1, config.maxLessons + 1);

  return (
    <tbody>
      {lessons.map((num, i) => {
        const subjectData = data[i];
        const { id } = subjectData || { id: num };

        return (
          subjectData
            ? <ScheduleRow
              key={id}
              num={num}
              studentId={studentId}
              currentTab={currentTab}
              data={subjectData}
            />
            : <ScheduleRowTemplate
              key={id}
              num={num}
            />
        );
      })}
    </tbody>
  );
};

export default ScheduleTableContent;
